import "@/App.css";
import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import TermsOfService from "./pages/TermsOfService";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import AgeGate from "./components/AgeGate";

// Wrapper to access location for age gate logic
function AppContent() {
  const [ageVerified, setAgeVerified] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const verified = localStorage.getItem('age_verified');
    if (verified === 'true') {
      setAgeVerified(true);
    }
  }, []);

  // Don't show age gate on legal pages
  const isLegalPage = location.pathname === '/terms' || location.pathname === '/privacy';
  const showAgeGate = !ageVerified && !isLegalPage;

  return (
    <>
      {showAgeGate && <AgeGate onVerify={() => setAgeVerified(true)} />}
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/payment-cancel" element={<PaymentCancel />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

export default App;
